import { Log, LogLevel, LogOrder, UserDoc } from '@gooduncles/gu-app-schema';

import { refreshSessionIfNeeded } from 'src/utils/common';
import { FirebaseManager } from 'src/utils/firebase/firebase-manager';

import { AuditLogger } from './audit-logger';

const firebaseManager = FirebaseManager.getInstance();
const auditLogger = AuditLogger.getInstance();
const logOrderPath = 'logOrder';

export class ConsoleLogger {
  private static instance: ConsoleLogger;
  private user: UserDoc | null;
  private publicIp: string;

  private constructor() {
    this.publicIp = 'unknown';
    this.user = null;
  }

  public static getInstance() {
    if (ConsoleLogger.instance === undefined) {
      ConsoleLogger.instance = new ConsoleLogger();
    }
    return ConsoleLogger.instance;
  }

  public setLoggerUser(user: UserDoc | null) {
    this.user = user;
  }

  public getLoggerUser() {
    return this.user;
  }

  public setPublicIp(ip: string) {
    this.publicIp = ip;
    auditLogger.setPublicIp(ip);
  }

  public getPublicIp() {
    return this.publicIp;
  }

  /** AuditLogger 인스턴스를 반환한다. */
  public getAuditLogger() {
    return auditLogger;
  }

  public logOrder(
    message: string,
    body: Omit<LogOrder, 'user'>,
    option?: {
      level?: LogLevel;
      channel?: '4-앱-알림' | 'dev';
      showBody?: boolean;
    },
  ) {
    const { level, channel, showBody } = option || {};

    const log: Log<LogOrder> = {
      level: level ?? 'log',
      sessionId: refreshSessionIfNeeded(),
      publicIp: this.publicIp,
      message,
      slack: {
        channel,
        showBody,
      },
      body: {
        ...body,
        user: this.user,
      },
    };

    if (!channel && !showBody) {
      delete log.slack;
    }

    return firebaseManager.createDoc(logOrderPath, undefined, log);
  }
}
